var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-edit-wrapper",
    { attrs: { company: _vm.value, "no-scroll": "" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c("w-input", {
            attrs: { "icon-left": "search" },
            model: {
              value: _vm.searchInput,
              callback: function ($$v) {
                _vm.searchInput = $$v
              },
              expression: "searchInput",
            },
          }),
        ],
        1
      ),
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              on: {
                click: function ($event) {
                  return _vm.addIconClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "plus" } })],
            1
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.editDisabled },
              on: {
                click: function ($event) {
                  return _vm.edit()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "pen" } })],
            1
          ),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.noModulesSelected },
              on: {
                click: function ($event) {
                  return _vm.removeIconClicked()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "minus" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1", "flex-shrink": "1" },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.sortedModules,
                  "selected-items": _vm.selectedRows,
                },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.edit($event)
                  },
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          model: {
            value: _vm.addOpened,
            callback: function ($$v) {
              _vm.addOpened = $$v
            },
            expression: "addOpened",
          },
        },
        [
          _c(
            "w-card",
            {
              style: { height: "90vh" },
              attrs: { "max-width": "1000", y: false },
            },
            [
              _c(
                "w-card-title",
                [
                  _vm._v(" Add module "),
                  _c("w-spacer"),
                  _c("w-input", {
                    attrs: { "icon-left": "search" },
                    model: {
                      value: _vm.addSearchInput,
                      callback: function ($$v) {
                        _vm.addSearchInput = $$v
                      },
                      expression: "addSearchInput",
                    },
                  }),
                ],
                1
              ),
              _c("w-data-table", {
                style: { flexGrow: 1 },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.allModules,
                  "selected-items": _vm.selectedAddRows,
                },
              }),
              _c(
                "w-card-actions",
                [
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.addOpened = false
                        },
                      },
                    },
                    [_vm._v(" Close ")]
                  ),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addModules()
                        },
                      },
                    },
                    [_vm._v(" Add ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditModule != null } },
        [
          _vm.toEditModule
            ? _c("app-company-edit-module-meta-data", {
                attrs: { value: _vm.toEditModule, company: _vm.value },
                on: {
                  close: function ($event) {
                    return _vm.closeEditModule()
                  },
                  saved: function ($event) {
                    return _vm.onMetaDataSaved($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }